export default __webpack_public_path__ + "static/media/cancel-request-icon.a8aba842.svg";